function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { axiosInstance } from '@applyboard/ui-utils';
import { API_PREFIX } from "../constants/consts";
export { getGradeSchemes, getProfileActionAxios } from "./profilePage";
export var getEducationLevels = function getEducationLevels() {
  return axiosInstance.get('/api/grades/education_levels');
};
export var load_search_profile = function load_search_profile(student_id, payload) {
  return axiosInstance.post("/students/load_search_profile?student_id=".concat(student_id), payload);
};
export var checkPayable = function checkPayable(orderId) {
  return axiosInstance.get("/api/orders/".concat(orderId, "/check_payable"));
};
export var programSearch = function programSearch(payload, schoolId) {
  return axiosInstance.post("/program_search.json".concat(schoolId ? "?school_id=".concat(schoolId) : ''), payload);
};
export var studentSearch = function studentSearch(query) {
  return axiosInstance.get("/api/v2/students_search?filter[q]=".concat(query));
};
export var profileSave = function profileSave(studentId, payload) {
  return axiosInstance.post("/students/load_search_profile?student_id=".concat(studentId), _objectSpread(_objectSpread({}, payload), {}, {
    student_id: studentId // eslint-disable-line camelcase
  }));
};
export var loadSearchProfile = function loadSearchProfile(studentId) {
  return axiosInstance.get("/students/load_search_profile.json?student_id=".concat(studentId));
};
export var loadStudentProfile = function loadStudentProfile(studentId) {
  return axiosInstance.get("".concat(API_PREFIX, "/students/").concat(studentId));
};